import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App';
import createStore from './store';

import {
  setCoordinate,
  setPanoramaById,
  setElevation,
  setElevationByCoordinate,
  setAddress,
} from './store/actions';

import { initializeServices, getMapLocations } from './lib/mapService';
import * as serviceWorker from './third_party/serviceWorker';
import createHandlePopState from './lib/handlePopState';
import { getPanoramaId, getCameraRotation } from './lib/url';
import { setRotation } from './store/panorama';
import { setMapUi } from './store/ui';

initializeServices();

const store = createStore();

setTimeout(() => { // defer
  const { ui, map } = store.getState();

  store.dispatch(setCoordinate(map.coordinate, false));

  if (!ui.isMapUi) {
    const panoramaId = getPanoramaId();

    getMapLocations().then((locations) => {
      const location = locations.find((l) => l.panoramaId === panoramaId);

      if (location === undefined) {
        store.dispatch(setMapUi(true));
        return;
      }

      const { elevation, lat, lng } = location;
      const coordinate = { lat, lng };

      store.dispatch(setPanoramaById(panoramaId, false));
      store.dispatch(setRotation(getCameraRotation(), false));
      store.dispatch(setCoordinate(coordinate, false));
      store.dispatch(setAddress(coordinate));

      if (elevation !== undefined) {
        store.dispatch(setElevation(elevation));
      } else {
        store.dispatch(setElevationByCoordinate(coordinate));
      }
    });
  }
}, 10);

window.addEventListener('popstate', createHandlePopState(store));

ReactDOM.render((
  <Provider store={store}>
    <App />
  </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
